import AddLesson from "./AddLesson";
import MainPage from "../../templatePage/templatePage";

const AddLessonPage = () => {
  return <MainPage component={<AddLesson />} />;
};

export default AddLessonPage;